module.exports = __webpack_public_path__ + "1af720c32bff5cb61e65b75fc9763885.png";


//////////////////
// WEBPACK FOOTER
// ./src/r-halo.png
// module id = 189
// module chunks = 0